import IconsApplePayFast from '~icons/icons/ApplePayFast.svg'
import IconsGooglePayFast from '~icons/icons/GooglePayFast.svg'
import IconsPayPalFast from '~icons/icons/PayPalFast.svg'
import type { FastCheckoutMethod } from '@design-system/composables/useFastCheckoutMethods'

/** Reduced logos shown in the "Fast checkout" row that opens the sidesheet. */
export const iconsMap: Record<FastCheckoutMethod, typeof IconsApplePayFast> = {
  applePay: IconsApplePayFast,
  googlePay: IconsGooglePayFast,
  payPal: IconsPayPalFast,
}
